<template>
  <v-container fluid>
    <v-layout
      row
      justify-center
    >
      <v-flex
        lg5
        md5
      >
        <v-card dark>
          <loading
            :active.sync="genUserLoading"
            :can-cancel="false" />

          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-card-text>
              <v-text-field
                v-model="username"
                :rules="[v => !!v || 'Email is required']"
                label="Email address"
                required />

              <v-text-field
                v-model="fullname"
                :rules="[v => !!v || 'Full Customer Name is required']"
                label="Full Customer Name"
                required />

              <v-select
                v-model="partner"
                :items="partner_item"
                :rules="[v => !!v || 'Partner is required']"
                label="Partner" />

              <v-text-field
                v-model="logtype"
                :rules="[v => !!v || 'Log Type is required']"
                label="Log type"
                required />

              <v-text-field
                v-model="date"
                :rules="[v => !!v || 'Start is required']"
                label="License Start Date"
                required />

              <v-text-field
                v-model="saleEmail"
                :rules="[v => !!v || 'Sale Email is required']"
                label="Sale Email"
               />
              <v-select
                v-model="indexmode"
                :items="indexmode_item"
                :rules="[v => !!v || 'Field is required']"
                label="TCCA / PDPA" />

              <v-text-field
                v-model="indexes_tcca"
                :rules="indexRule"
                :items="options_tcca"
                label="Index TCCA"
              />
              <v-text-field
               v-if="indexmode == 'pdpa'"
                v-model="indexes_pdpa"
                :rules="indexRule"
                :items="options_pdpa"
                label="Index PDPA"
              />

              <!-- <v-text-field
                  v-model="index"
                  label="Index"
                  required /> -->

              <v-text-field
                v-model="instance"
                :rules="[v => !!v || 'Instance is required']"
                :prefix="instancePrefix"
                label="Instance IP" />

              <v-text-field
                v-model="lic"
                :rules="[v => !!v || 'License is required']"
                label="License (POC or Number)" />

              <v-menu
                v-if="lic && lic !== 'POC'"
                v-model="isPickerStartDateShown"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                offset-y
                full-width
                min-width="300px"
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="startDate"
                    label="Start Date"
                    prepend-icon="event"
                    v-on="on" />
                </template>

                <v-date-picker
                  v-model="startDate"
                  dark
                  @input="isPickerStartDateShown = false"
                >
                  <v-spacer />
                </v-date-picker>
              </v-menu>

              <v-menu
                v-if="lic && lic !== 'POC'"
                v-model="isPickerStartEndShown"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                offset-y
                full-width
                min-width="300px"
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="endDate"
                    label="End Date"
                    prepend-icon="event"
                    v-on="on" />
                </template>

                <v-date-picker
                  v-model="endDate"
                  dark
                  @input="isPickerStartEndShown = false"
                >
                  <v-spacer />
                </v-date-picker>
              </v-menu>

              <v-flex
                xs12
                class="
                  text-xs-center
                  text-sm-center
                  text-md-center
                  text-lg-center
                "
              >
                <v-btn
                  slot="activator"
                  flat
                  icon
                  dark
                  @click="pickFile"
                >
                  <v-tooltip bottom>
                    <v-icon slot="activator">add_photo_alternate</v-icon>

                    <span>Add Image</span>
                  </v-tooltip>
                </v-btn>

                <v-card v-if="imageName">
                  <img
                    v-if="imageUrl"
                    :src="imageUrl"
                    height="150" >

                  <v-card-title primary-title>
                    <h3>{{ imageName }}</h3>
                  </v-card-title>
                </v-card>

                <input
                  ref="image"
                  type="file"
                  style="display: none"
                  name="image"
                  accept="image/*"
                  @change="onFilePicked" >
              </v-flex>
            </v-card-text>

            <v-card-actions>
              <v-spacer />

              <v-btn
                slot="activator"
                flat
                icon
                @click.native="generateUser"
              >
                <v-icon>check</v-icon>
              </v-btn>

              <v-btn
                slot="activator"
                flat
                icon
                @click.native="clear"
              >
                <v-icon>cancel</v-icon>
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>

    <v-snackbar
      v-model="snackbar"
      :bottom="false"
      :left="false"
      :multi-line="true"
      :right="false"
      :timeout="6000"
      :top="true"
      :vertical="false"
    >
      {{ snackbartext }}
      <v-btn
        color="pink"
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
  import axios from 'axios'
  import loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import jwtDecode from 'jwt-decode'
  export default {
    name: 'generateUser',
    components: {
      loading
    },
    data () {
      return {
        snackbar: false,
        snackbartext: '',
        indexmode: 'tcca',
        indexmode_item: [
          {
            text: 'TCCA',
            value: 'tcca'
          },
          {
            text: 'PDPA',
            value: 'pdpa'
          }
        ],
        genUserLoading: false,
        valid: true,
        username: '',
        indexes_tcca: '',
        indexes_pdpa: 'pdpa',
        instance: '',
        instancePrefix: 'http://3.1.180.118:',
        lic: '',
        options_tcca: [],
        options_pdpa: [],
        fullname: '',
        partner: '',
        date: '',
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date(new Date().getTime() + (365 * 24 * 60 * 60 * 1000)).toISOString().substr(0, 10),
        logtype: '',
        saleEmail: '',
        imageName: '',
        imageUrl: '',
        imageFile: '',
        isPickerStartDateShown: false,
        isPickerStartEndShown: false,
        indexRule: [
          (v) => {
            if (!v || v.length === 0) {
              return 'Index is required'
            } else return true
          }
        ],
        partner_item: [
          {
            text: 'AIS',
            value: 'AIS'
          },
          {
            text: 'INET',
            value: 'INET'
          },
          {
            text: 'DIRECT',
            value: 'DIRECT'
          }
        ],
        token: null,
        ampid: null
      }
    },

    created () {
        this.token = sessionStorage.getItem('user-token')
        let decoded = jwtDecode(this.token)
        this.ampid = decoded.ampid
    },

    computed: {
      fullStartDate: function () {
        return new Date(this.startDate)
      },

      fullEndDate: function () {
        return new Date(this.endDate)
      }
    },

    methods: {
      async generateUser () {
        if (this.$refs.form.validate()) {
          window.analytics.track(`[Administrator][Generate User][Submit]`, {
            value: {
                  username: this.username,
                  lic: this.lic,
                  fullname: this.fullname,
                  partner: this.partner,
                  saleEmail: this.saleEmail
              }
          },
          {
              integrations: {
                  Amplitude: {
                  'session_id': this.ampid
                  }
              }
          })
          this.genUserLoading = true
          this.snackbartext = 'We are generating user account, Pleas wait'
          this.snackbar = true
          var formData = new FormData()
          let body = {
            username: this.username,
            instance: this.instancePrefix + this.instance,
            index: this.indexes_tcca.split(','),
            index_pdpa: this.indexes_pdpa.split(','),
            lic: this.lic,
            fullname: this.fullname,
            partner: this.partner,
            date: this.date,
            startDate: (this.lic === 'POC'
              ? null
              : this.fullStartDate),
            endDate: (this.lic === 'POC'
              ? null
              : this.fullEndDate),
            onlineRetention: '30',
            offlineRetention: '90',
            logtype: this.logtype,
            saleEmail: this.saleEmail,
            image: this.imageName
          }
          if (this.imageFile !== '') {
            formData.append('image', this.imageFile)
            await axios.post(apiUrl + '/api/auth/uploadImage', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
          }
          let response = await axios.post(apiUrl + '/api/auth/generate_user',
            body)
          // alert(response.data.msg)
          this.genUserLoading = false
          this.snackbar = false
          this.snackbartext = response.data.msg
          this.snackbar = true
        }
      },

      clear () {
        this.username = ''
        this.indexes_tcca = []
        this.indexes_pdpa = []
        this.instance = ''
        this.lic = ''
        this.fullname = ''
        this.date = ''
        this.logtype = ''
        this.saleEmail = ''
        window.analytics.track(`[Administrator][Generate User][Cancel]`, {
          },
          {
              integrations: {
                  Amplitude: {
                  'session_id': this.ampid
                  }
              }
          })
      },

      pickFile () {
        this.$refs.image.click()
      },

      onFilePicked (e) {
        const files = e.target.files
        this.imageFile = files[0]
        if (files[0] !== undefined) {
          this.imageName = files[0].name
          if (this.imageName.lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.imageUrl = fr.result
            // this.imageFile = files[0]
            // this is an image file that can be sent to server...
          })
        } else {
          this.imageName = ''
          this.imageFile = ''
          this.imageUrl = ''
        }
    },
    watch: {
      startDate: {
        handler: function (startDate) {
          this.endDate = new Date(new Date(this.startDate).getTime() + (365 * 24 * 60 * 60 * 1000)).toISOString().substr(0, 10)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/generateUser.vue